/// <reference path="../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmOAuth extends GContentBase<SeznamAdmOAuthObj> {
        private seznamObj: SeznamAdmOAuthObj & GContent;
        //private adminConsentOnly: boolean;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmOAuthObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmOAuthNew",
                contentCaption: (this.adminConsentTokensOnly == true) ? "jres:33000392" : "jres:33000378", //RC 33000392 : Admin consent tokeny
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    addComparator: false,
                    itemTemplate: "{}"
                },
                gridSettings: {
                    columnOrder: "ixs_ref_txt,dat_zmena,dat_exp,ixs_oap_txt,expirace_txt,{0}oauth_service_txt,secret_scope_txt,faze,service_scopes".format((this.adminConsentTokensOnly == true) ? "" : "oa_token_typ_txt,")
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();

            //this.menuBar(this.actions.createBar(["actTestOAuth*", "actTestSaveOAuth*", "actTestListOAuth*", "actTestReadOAuth*", "actTestDeleteOAuthToken*"]))
            //$("<div class='test-o-auth' style='margin: 1rem'>").appendTo(this.element)
        }
    }

    export enum TypeDialogs {
        consent,
        login,
    }

    export class SeznamAdmOAuthObj extends GAdmSeznamBase {
        adminConsentTokensOnly: boolean;
        private serviceCnt: GContent;
        private isDebug: boolean;
        

        private srv(): GContent {
            if (!this.serviceCnt)
                this.serviceCnt = this.cnt.createServiceContent("Gordic.Adm.WebControls.SeznamAdmOAuth")
            return this.serviceCnt;
        }


        create() {
            if (this.adminConsentTokensOnly == false)
                this.cnt.showFlash({
                    content: "jres:33000648", //RC 33000648 : Zde jsou zobrazené veškeré vydané tokeny za celou databázi.
                    state: "info"
                })
        }

        openDetail(data: any, isNew: boolean) {
            
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actTestOAuth: {
                    caption: "jres:33000391", //RC 33000391 : Login OAuth
                    icon: "fa-external-link",
                    //visible: this.isDebug,
                    run: (ev, ctx) => {
                        this.createOAuthProfileDialog(TypeDialogs.login);
                    }
                },
                actTestOAuthConsent: {
                    caption: "jres:33000390", //RC 33000390 : Získat OAuth consent
                    icon: "fa-external-link",
                    //visible: this.isDebug,
                    run: (ev, ctx) => {
                        this.createOAuthProfileDialog(TypeDialogs.consent);
                    }
                },
                actTestDeleteOAuthToken: {
                    caption: "jres:33000379", //RC 33000379 : Deaktivovat OAuth tokeny
                    icon: "gi-window-close",
                    run: (ev, ctx) => {
                        this.deactivateTokens()
                    }
                },
                actOAuthProfilSelectConsentOk: {
                    caption: "jres:33000243",
                    run: (ev, ctx) => {
                        this.oAuthProfilConsentOK(ev, ctx);
                    }
                },
                actOAuthProfilSelectLoginOk: {
                    caption: "jres:33000243",
                    run: (ev, ctx) => {
                        this.oAuthProfilLoginOK(ev, ctx);
                    }
                },
                actOAuthProfilSelectCancel: {
                    caption: "jres:32131042",
                    run: (ev, ctx) => {
                        this.oAuthProfilCancel(ev, ctx);
                    }
                },
                actOAuthTokenDeleteHromadne: {
                    icon: "gi-window-close",
                    caption: "jres:33000396", //RC 33000396 : Smazat hromadně
                    tooltip: "jres:33000397", //RC 33000397 : Funkce smaže všechny pomocné tokeny
                    run: (ev, ctx) => {
                        this.oAuthTokenDeleteHromadneConfirm()
                    }
                },
                actExtendOAuthConsent: {
                    icon: "gi-time",
                    caption: "jres:33000539", //RC 33000539 : Prodloužení souhlasu
                    tooltip: "jres:33000540", //RC 33000540 : Umožňuje prodloužit souhlas
                    run: (ev, ctx) => {
                        this.oAuthConsentExtend();
                    }
                },
                actExtendOAuthConsentOk: {
                    caption: "jres:33000243",
                    run: (ev, ctx) => {
                        this.oAuthConsentExtendOK(ev);
                    }
                },
                actExtendOAuthConsentCancel: {
                    caption: "jres:32131042",
                    run: (ev, ctx) => {
                        $.content(ev.target).close();
                    }
                }
                //actTestConsent: {
                //    icon: "fa-play",
                //    caption: "jres:33000401", //RC 33000401 : Otestovat
                //    run: (ev, ctx) => {
                //        this.OAuthTestConsent(ev, ctx)
                //    }
                //}
            }
        }

        private deactivateTokens() {
            var tokens = this.grid.ggrid("getSelection");
            this.cnt.beginOperation();
            this.srv().call("DeactivateTokens", { tokens: tokens }).done((successDeactivateTokens) => {
                this.cnt.notification("add", {
                    title: "jres:33000378",
                    content: "jres:33000380".format(successDeactivateTokens, tokens.length - successDeactivateTokens), //RC 33000380 : Tokeny byly úspěšně deaktivovány.
                    state: "info"
                }, true)
            }).always(() => {
                this.cnt.endOperation();
                this.applydata(this.filterData);
            })
        }

        private createOAuthProfileDialog(type: TypeDialogs) {
            var form = new Gordic.Forms.Form({
                layoutDescriptor: "L1M1S1",
                name: "selectOAuthProfilForm",
                customClass: "selectOAuthProfilForm"
            }).addRow("jres:33000394").addField("gselectbox", Gordic.Prefabs.Select.gincose(), { //RC 33000394 : Služba
                name: "sluzba",
                model: "model.oauth_service=value.oauth_service;model.oauth_service_txt<=value.oauth_service_txt",
                dropdown: true,
                validators: [new Gordic.Validators.Required({ stopping: true })],
                flag: "required",
            }).addRow("jres:33000388").addField("gselectbox", Gordic.Prefabs.Select.ginsoap(), { //RC 33000388 : OAuth profil
                name: "profil",
                model: "model.ixs_oap=value.ixs_oap;model.ixs_oap_txt<=value.nazev",
                dropdown: true,
                validators: [new Gordic.Validators.Required({ stopping: true })],
                flag: "required",
                serverFilters: {
                    typ_aut_oauth: (type == TypeDialogs.consent) ? 10 : null
                }
            })

            this.cnt.dialogs.simpleForm("jres:33000391", form, null, { //RC 33000389 : Vyberte OAuth profil
                dialogClass: "oauth-profil",
                height: 200,
                open: (ev) => {
                    var field = $(ev.target as any).findFields("profil");
                    field.gfield("clearClientCache");
                },
                commandBar: [
                    {
                        action: (type == TypeDialogs.consent) ? this.cnt.actions.actOAuthProfilSelectConsentOk : this.cnt.actions.actOAuthProfilSelectLoginOk,
                        primary: true
                    },
                    {
                        action: this.cnt.actions.actOAuthProfilSelectCancel,
                    }
                ]
            }) 
        }

        private oAuthProfilConsentOK(ev, ctx) {
            var cnt = $.content($(ev.target));
            var form = cnt.findForms("selectOAuthProfilForm");
            if (form.gform("isValid")) {
                var data: any = {};
                form.findFields().gfield("model", "collect", data)
                this.ziskatOAuthConsent(data);
                cnt.close();
            }
        }

        private oAuthProfilLoginOK(ev, ctx) {
            var cnt = $.content($(ev.target));
            var form = cnt.findForms("selectOAuthProfilForm");
            if (form.gform("isValid")) {
                var data: any = {};
                form.findFields().gfield("model", "collect", data)
                this.testLoginOAuth(data);
                cnt.close();
            }
        }

        private ziskatOAuthConsent(data) {
            this.srv().call("ZiskatOAuthConsent", { ixs_oap: data.ixs_oap, sluzba: data.oauth_service }).done((output: Gordic.Gin.Interface.GAdmOAuthDto) => {
                //if (this.isDebug == true)
                //    console.log(output.State)
                //$(".test-o-auth").text(output.state ? output.state : "");
            }).done((obj) => {
                if (obj.Url) {
                    if (this.isDebug == true)
                        console.log(atob(obj.Url));
                    window.open(atob(obj.Url), "_blank");
                } else {
                    this.applydata(this.filterData);
                    this.cnt.dialogs.alert("jres:33000390", "jres:33000848".format(data.oauth_service_txt, data.ixs_oap_txt)) //RC 33000848 : Souhlas pro <b>{0}</b> na OAuth profilu <b>{1}</b> byl již pravděpodobně získán.
                }
            })
        }

        private oAuthProfilCancel(ev, ctx) {
            var cnt = $.content($(ev.target));
            cnt.close();
        }

        private testLoginOAuth(data: any) {
            this.srv().call("TestOAuth", { ixs_oap: data.ixs_oap, sluzba: data.oauth_service }).done((output: Gordic.Gin.Interface.GAdmOAuthDto) => {
                //if (this.isDebug == true)
                //    console.log(output.State)
                //$(".test-o-auth").text(output.state ? output.state : "");
            }).done((obj) => {
                if (obj.Url) {
                    if (this.isDebug == true)
                        console.log(atob(obj.Url));
                    window.open(atob(obj.Url), "_blank");
                } else {
                    this.applydata(this.filterData);
                    this.cnt.dialogs.alert("jres:33000391", "jres:33000847".format(data.oauth_service_txt, data.ixs_oap_txt)) //RC 33000847 : Službu <b>{0}</b> na OAuth profilu <b>{1}</b> je pravděpodobně možné používat.
                }
            })
        }

        createBaseMenuBarActions() {
            var actionsArray: string[] = [];
            if (this.adminConsentTokensOnly == true) {
                actionsArray.push("actTestOAuthConsent*")
                actionsArray.push("actExtendOAuthConsent*")
                //actionsArray.push("actTestConsent*")
            } else
                actionsArray.push("actTestOAuth*")
            actionsArray.push("actTestDeleteOAuthToken*")
            if (this.adminConsentTokensOnly == false)
                actionsArray.push("actOAuthTokenDeleteHromadne*")
            this.cnt.menuBar(this.cnt.actions.createBar(actionsArray));
            //this.cnt.menuBar(this.cnt.actions.createBar(["actTestOAuth*", "actTestOAuthConsent*", /*"actTestSaveOAuth*", "actTestListOAuth*", "actTestReadOAuth*",*/ "actTestDeleteOAuthToken*"]))
        }

        createContextMenu(): MenuParams[] {
            var actionsArray: string[] = [];
            //if (this.adminConsentTokensOnly == true)
            //    actionsArray.push("actTestConsent*");
            actionsArray.push("actTestDeleteOAuthToken*");
            return this.cnt.actions.createBar(actionsArray);
        }

        createFilterForm() {
            if (this.adminConsentTokensOnly == false) {
                this.filterForm.addRow("jres:33000383").addField("gselectbox", Gordic.Prefabs.Select.gincoat(), { //RC 33000383 : Typ OAuth tokenu
                    name: "oa_token_typ",
                    model: "model.oa_token_typ=value.oa_token_typ",
                    dropdown: true,
                    serverFilters: {
                        oa_token_typ: [ 0, 10, 20, 30, 40, 50, 60]
                    }
                })
            }
            this.filterForm.addRow("jres:33000384").addField("gselectbox", Gordic.Prefabs.Select.gincose(), {  //RC 33000384 : Služba
                name: "oauth_service",
                model: "model.oauth_service=value.oauth_service",
                dropdown: true
            }).addRow("jres:33000386").addField("gselectbox", Gordic.Prefabs.Select.ginsoap(), {
                name: "ixs_oap",
                model: "model.ixs_oap=value.ixs_oap",
                dropdown: true,
                serverFilters: {
                    aktivita: [100, 300, 500, 600, 900]
                }
            })
        }

        userhardDefaultFilter(hardFilter: any): any {
            return hardFilter;
        }

        collectData(data: any) {
            if (this.adminConsentTokensOnly == true)
                data.oa_token_typ = 70
            else {
                if (data.oa_token_typ == null)
                    data.oa_token_typ = [0, 10, 20, 30, 40, 50, 60]
            }
        }

        applydata(filterData: any) {
            this.cnt.beginOperation();
            this.cnt.isl.AdmOAuthToken.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.setExpiraceTextColumn(this.view);
                this.grid.ggrid('setData', this.view);
            }).always(() => { this.cnt.endOperation() });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {
            this.cnt.actions.actTestDeleteOAuthToken?.update({ enabled: objArr.count > 0 })
            this.cnt.actions.actExtendOAuthConsent?.update({ enabled: objArr.count > 0 })
            //this.cnt.actions.actTestConsent?.update({ enabled: objArr.count > 0 })
        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "",
                nazev: ""
            }
        }

        private setExpiraceTextColumn(data: Data.View) {
            data.process({
                ac: new Gordic.Data.ComputedFieldsProcessor(
                    (rows) => {
                        rows.forEach((row) => {
                            row.data.expirace_txt = this.createPlatnostText(row.data)
                        })
                    }
                )
            })
        }

        private createPlatnostText(data: AdmIsl.Interface.GAdmOAuthTokenListDto): string {
            var diff = Math.floor(new Date(data.dat_exp as any).getTime() / 1000) - Math.floor(new Date().getTime() / 1000);
            if (diff <= 0)
                return "jres:33000382" //RC 33000382 : Expirováno
            else
                return this.secondsToText(diff);
        }

        private secondsToText(sec: number): string {
            sec = Number(sec);
            var d = Math.floor(sec / (3600 * 24))
            var h = Math.floor((sec % (3600 * 24)) / 3600);
            var m = Math.floor((sec % (3600 * 24)) % 3600 / 60);
            var s = Math.floor((sec % (3600 * 24)) % 3600 % 60);

            var dDisplay = d > 0 ? d + " d" : "";
            var hDisplay = h > 0 ? h + " h" : "";
            var mDisplay = m > 0 ? m + " m" : "";
            var sDisplay = s > 0 ? s + " s" : "";
            return dDisplay + " " + hDisplay + " " + mDisplay + " " + sDisplay;
        }

        private oAuthTokenDeleteHromadneConfirm() {
            this.cnt.dialogs.confirm("jres:33000257", "jres:33000398").on("yes", () => { //RC 33000398 : Opravdu si přejete smazat všechny pomocné tokeny?
                this.cnt.isl.AdmOAuthToken.deleteHromadne({
                    filters: {
                        oa_token_typ: [ 20, 30, 40, 50, 60 ]
                    }
                }).getData().done(() => {
                    this.applydata(this.filterData);
                    this.cnt.notification("add", {
                        title: "jres:33000378",
                        content: "jres:33000399",  //RC 33000399 : Pomocné tokeny byly odstraněny.
                        state: "success"
                    }, true)
                })
            }) 
        }

        private oAuthConsentExtend() {
            var selectData = [
                { caption: "jres:33000542", value: 1 }, //RC 33000542 : 1 měsíc
                { caption: "jres:33000543", value: 3 }, //RC 33000543 : 3 měsíce
                { caption: "jres:33000544", value: 6 }, //RC 33000544 : 6 měsíců
                { caption: "jres:33000545", value: 9 }, //RC 33000545 : 9 měsíců
                { caption: "jres:33000546", value: 12 }, //RC 33000546 : 1 rok
            ]

            var form = new Gordic.Forms.Form({ name: "from-extend-consent" })
                .addRow("jres:33000541").addField("gselectbox", { //RC 33000541 : Prodloužit o
                    name: "month",
                    data: selectData,
                    initialValue: selectData[4],
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    itemTemplate: "{caption}",
                    dropdown: true,
                    flag: "required"
                }) 

            this.cnt.dialogs.simpleForm("jres:33000547", form, null, {  //RC 33000547 : Prodloužení souhlasu
                height: 200,
                width: 450,
                commandBar: this.cnt.actions.createBar([{ action: this.cnt.actions.actExtendOAuthConsentOk, primary: true }, "actExtendOAuthConsentCancel*"])
            })
        }

        private oAuthConsentExtendOK(ev) {
            var row = this.grid.ggrid("activeRow");
            var cnt = $.content(ev.target);
            if (row) {
                var data = row;
                data.dat_zmena = null;
                data.zmenu_prov = null;
                var form = cnt.findForms("from-extend-consent");
                if (form.gform("isValid")) {
                    var month = form.findFields("month").gfield("getValue");
                    if (month && data.dat_exp) {
                        data.dat_exp = Gordic.Utils.DateTime.addMonths(new Date(data.dat_exp.toString()), month.value);
                        data.NewRecord = false;
                        this.cnt.isl.AdmOAuthToken.upsert({ data: data }).getData().done((out) => {
                            this.cnt.notification("showToast", {
                                title: this.options.contentCaption,
                                state: "success",
                                content: "jres:33000548" //RC 33000548 : Prodloužení tokenu proběhlo úspěšně.
                            })
                            this.applydata(this.filterData);
                            cnt.close();
                        })
                    } else {
                        cnt.close();
                    }
                }
            }
        }

        //private OAuthTestConsent(ev, ctx) {
        //    var data = this.grid.ggrid("activeRow");
        //    if (!data) {
        //        this.cnt.notification("showToast", {
        //            title: this.options.contentCaption,
        //            content: "jres:33000402", //RC 33000402 : Nevybrán žádný záznam, nelze otestovat.
        //            state: "error",
        //            icon: "fa-times-error"
        //        })
        //    } else {
        //         this.srv().call("TestOAuthConsent", { oauthConsent: data }).done((obj) => {

        //         })
        //    }
        //}
    }
}